export default __webpack_public_path__ + "static/media/happyman.ec56ef91.png";